import repeatBlackIcon from "../../assets/img/modals/repeat-black.svg";
import repeatIcon from "../../assets/img/modals/repeat.svg";
import integration_google_analytics from "../../assets/img/modals/integration-google-analytics.svg";
import integration_facebook_analytics from "../../assets/img/modals/integration-facebook-pixel.svg";
import integration_mailchimp from "../../assets/img/modals/integration-mailchimp.svg";
import integration_convertkit from "../../assets/img/modals/integration-convertkit.svg";
import integration_sendinblue from "../../assets/img/modals/integration-sendinblue.svg";
import { Modal } from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { hideLoader, showLoader } from "../loader";
import returnIcon from "../../assets/img/modals/return.svg";
import { useDispatch, useSelector } from "react-redux";
import ModalErrors from "../errors/modal-errors";
import { toast } from "react-toastify"
import { apiUrl } from "../../utils/url";
import integration_zapier from "../../assets/img/modals/integration-zapier.svg";
import integration_instantly from "../../assets/img/modals/integration-instantly.svg";

export const GoogleAnalyticsModal = ({ show, handleClose, error, handleSubmit }) => {

    const dispatch = useDispatch()
    const value = useSelector(state => state?.integrationGoogleReducer);
    const handleChange = (e) => dispatch({ type: "SET_GOOGLE_INTEGRATION", payload: { ...value, [e.target.name]: e.target.value } });

    return (

        <Modal show={show} onHide={handleClose} id="googleAnalyticsModal" centered>
            <div class="modal-dialog-centered" role="document">
                <div class="modal-content modal-semi-curve overflow-none">

                    <div class="modal-body">

                        <form name="create_folder" method="post" role="form" onSubmit={(e) => handleSubmit(e, value, "google")}>
                            <div class="notification-container"></div>


                            <div class="form-group">
                                <img src={integration_google_analytics} width="30px" alt="" />
                                <h4 class="mt-2 mb-1">Google Analytics</h4>
                            </div>

                            <div class="form-group mt-3">
                                <label><small>Google Analytics ID</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="analytics_id" value={value?.analytics_id} required="required" placeholder="Google Analytics ID" onChange={handleChange} />
                                <p style={{ marginBottom: 0 }}><ModalErrors text={error} /></p>
                                <small class="text-muted-light">Enable tracking with Google Analytics by adding your analytics ID<br />(ex: UA-22222222-33)</small>
                            </div>

                            <div class="text-center mt-4 d-flex">
                                <button type="button" onClick={handleClose} class="close btn btn-grey btn-semi-rounded me-2 d-flex align-items-center justify-content-center">
                                    <b class="me-2">Cancel</b>
                                    <small class="badge bg-light text-dark p-1">Esc</small>
                                </button>
                                <button type="submit" class="btn btn-primary btn-semi-rounded d-flex align-items-center justify-content-center">
                                    <b class="me-2">Save Changes</b>
                                    <small class="badge bg-primary-dark text-dark px-2 py-1 d-flex align-items-center justify-content-center">
                                        <img src={returnIcon} alt="" />
                                    </small>
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </Modal>
    )
}
export const FacebookPixelModal = ({ show, handleClose, handleSubmit, error }) => {
    const dispatch = useDispatch()
    const value = useSelector(state => state?.integrationFacebookReducer);

    const handleChange = (e) => dispatch({ type: "SET_FACEBOOK_INTEGRATION", payload: { ...value, [e.target.name]: e.target.value } });
    return (

        <Modal show={show} onHide={handleClose} id="facebookPixelModal" centered>
            <div class="modal-dialog-centered" role="document">
                <div class="modal-content modal-semi-curve overflow-none">

                    <div class="modal-body">

                        <form name="create_folder" method="post" role="form" onSubmit={(e) => handleSubmit(e, value, "facebook")}>
                            <div class="notification-container"></div>


                            <div class="form-group">
                                <img src={integration_facebook_analytics} width="30px" alt="" />
                                <h4 class="mt-2 mb-1">Facebook Pixel</h4>
                            </div>

                            <div class="form-group mt-3">
                                <label><small>Facebook Pixel ID</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="pixel_id" onChange={handleChange} value={value?.pixel_id} required="required" placeholder="Facebook Pixel ID" />
                                <ModalErrors text={error} />
                                <small class="text-muted-light">Enable the Facebook Pixel by adding your only the Facebook Pixel ID.</small>
                            </div>

                            <div class="text-center mt-4 d-flex">
                                <button type="button" onClick={handleClose} class="close btn btn-grey btn-semi-rounded me-2 d-flex align-items-center justify-content-center">
                                    <b class="me-2">Cancel</b>
                                    <small class="badge bg-light text-dark p-1">Esc</small>
                                </button>
                                <button type="submit" class="btn btn-primary btn-semi-rounded d-flex align-items-center justify-content-center">
                                    <b class="me-2">Save Changes</b>
                                    <small class="badge bg-primary-dark text-dark px-2 py-1 d-flex align-items-center justify-content-center">
                                        <img src={returnIcon} alt="" />
                                    </small>
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </Modal>
    )
}
export const MailchimpModal = ({ show, handleClose, handleSubmit, error }) => {
    const dispatch = useDispatch()
    const value = useSelector(state => state?.integrationMailChimpReducer);
    const handleChange = (e) => dispatch({ type: "SET_MAILCHIMP_INTEGRATION", payload: { ...value, [e.target.name]: e.target.value } });
    return (
        <Modal show={show} onHide={handleClose} id="mailchimpModal" centered>
            <div class="modal-dialog-centered" role="document">
                <div class="modal-content modal-semi-curve overflow-none">
                    <div class="modal-body">
                        <form name="create_folder" method="post" role="form" onSubmit={(e) => handleSubmit(e, value, "mailchimp")}>
                            <div class="notification-container"></div>
                            <div class="form-group">
                                <img src={integration_mailchimp} width="40px" alt="" />
                                <h4 class="mt-2 mb-1">Connect Mailchimp</h4>
                                <p class="text-gray font-weight-500">Send new email subscribers to your Mailchimp list from Zaap.</p>
                            </div>

                            <div class="form-group">
                                <label><small>API Key</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="api_key" value={value?.api_key} onChange={handleChange} required="required" placeholder="API Key" />
                            </div>

                            <div class="form-group mt-2">
                                <label><small>Server Prefix</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="server_prefix" value={value?.server_prefix} onChange={handleChange} required="required" placeholder="Server Prefix" />
                            </div>

                            <div class="form-group mt-2">
                                <label><small>List ID</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="list_id" value={value?.list_id} onChange={handleChange} required="required" placeholder="List ID" />
                            </div>


                            <div class="text-center mt-4 d-flex">
                                <button type="button" onClick={handleClose} class="close btn btn-grey btn-semi-rounded me-2 d-flex align-items-center justify-content-center">
                                    <b class="me-2">Cancel</b>
                                    <small class="badge bg-light text-dark p-1">Esc</small>
                                </button>
                                <button type="submit" class="btn btn-primary btn-semi-rounded d-flex align-items-center justify-content-center">
                                    <b class="me-2">Save Changes</b>
                                    <small class="badge bg-primary-dark text-dark px-2 py-1 d-flex align-items-center justify-content-center">
                                        <img src={returnIcon} alt="" />
                                    </small>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export const ConvertkitModal = ({ show, handleClose, handleSubmit, error }) => {


    const dispatch = useDispatch()
    const value = useSelector(state => state?.integrationConvertkitReducer);
    const handleChange = (e) => dispatch({ type: "SET_CONVERTKIT_INTEGRATION", payload: { ...value, [e.target.name]: e.target.value } });
    return (
        <Modal show={show} onHide={handleClose} id="convertkit" centered>
            <div class="modal-dialog-centered" role="document">
                <div class="modal-content modal-semi-curve overflow-none">

                    <div class="modal-body">

                        <form name="create_folder" method="post" role="form" onSubmit={(e) => handleSubmit(e, value, "convertkit")}>
                            <div class="form-group">
                                <img src={integration_convertkit} width="30px" alt="" />
                                <h4 class="mt-2 mb-1">Connect ConvertKit</h4>
                                <p class="text-gray font-weight-500">Send new email subscribers to your ConvertKit list from Znaplink.</p>
                            </div>

                            <div class="form-group">
                                <label><small>API Key</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="api_key" onChange={handleChange} value={value?.api_key} required="required" placeholder="API Key" />
                            </div>

                            <div class="form-group mt-2">
                                <label><small>Form ID (Collects only email)</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="form_id" onChange={handleChange} value={value?.form_id} required="required" placeholder="Form ID" />
                            </div>


                            <div class="text-center mt-4 d-flex">
                                <button type="button" onClick={handleClose} class="close btn btn-grey btn-semi-rounded me-2 d-flex align-items-center justify-content-center">
                                    <b class="me-2">Cancel</b>
                                    <small class="badge bg-light text-dark p-1">Esc</small>
                                </button>
                                <button type="submit" class="btn btn-primary btn-semi-rounded d-flex align-items-center justify-content-center">
                                    <b class="me-2">Save Changes</b>
                                    <small class="badge bg-primary-dark text-dark px-2 py-1 d-flex align-items-center justify-content-center">
                                        <img src={returnIcon} alt="" />
                                    </small>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export const SendinblueModal = ({ show, handleClose, handleSubmit, error }) => {
    const dispatch = useDispatch()
    const value = useSelector(state => state?.integrationSendinblueReducer);
    const handleChange = (e) => dispatch({ type: "SET_SENDINBLUE_INTEGRATION", payload: { ...value, [e.target.name]: e.target.value } });

    return (
        <Modal show={show} onHide={handleClose} id="sendinblue" centered>
            <div class="modal-dialog-centered" role="document">
                <div class="modal-content modal-semi-curve overflow-none">

                    <div class="modal-body">

                        <form name="create_folder" method="post" role="form" onSubmit={(e) => handleSubmit(e, value, "sendinblue")}>
                            <div class="notification-container"></div>

                            <div class="form-group">
                                <img src={integration_sendinblue} width="30px" alt="" />
                                <h4 class="mt-2 mb-1">Connect SendInBlue</h4>
                                <p class="text-gray font-weight-500">Send new email subscribers to your SendInBlue list from Znaplink.</p>
                            </div>

                            <div class="form-group">
                                <label><small>API Key</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="api_key" value={value?.api_key} onChange={handleChange} required="required" placeholder="API Key" />
                            </div>

                            <div class="form-group mt-2">
                                <label><small>List ID</small></label>
                                <input type="text" class={`form-control zaap-form-control`} name="list_id" value={value?.list_id} onChange={handleChange} required="required" placeholder="List ID" />
                            </div>


                            <div class="text-center mt-4 d-flex">
                                <button type="button" onClick={handleClose} class="close btn btn-grey btn-semi-rounded me-2 d-flex align-items-center justify-content-center">
                                    <b class="me-2">Cancel</b>
                                    <small class="badge bg-light text-dark p-1">Esc</small>
                                </button>
                                <button type="submit" class="btn btn-primary btn-semi-rounded d-flex align-items-center justify-content-center">
                                    <b class="me-2">Save Changes</b>
                                    <small class="badge bg-primary-dark text-dark px-2 py-1 d-flex align-items-center justify-content-center">
                                        <img src={returnIcon} alt="" />
                                    </small>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export const ConnectZapierModal = ({type, text, show, handleClose, handleSubmit, error }) => {
    const dispatch = useDispatch()
    const value = useSelector(state => state?.integrationZapierReducer);
    const handleChange = (e) => dispatch({ type: "SET_ZAPIER_INTEGRATION", payload: {  ...value, [e.target.name]: e.target.value,tab:"integrations" } });
    return (

        <Modal show={show} onHide={handleClose} className="rename-modal" centered>
            <div class="modal-dialog-centered" role="document">
                <div class="modal-content modal-semi-curve overflow-none">
                    <div className="modal-header">          
                        <div className="d-flex gap-2 align-items-center">
                            <img src={integration_zapier} alt="" width={30} />
                            <div>Connect Zapier to GenPage</div>
                        </div>                  
                        <button type="button" class="close" onClick={handleClose} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <form name="create_folder" method="post" role="form" onSubmit={(e) => handleSubmit(e, value, type)}>
                            <div class="notification-container"></div>
                            <div class="form-group">
                                <label className='fs-12 font-weight-500' htmlFor="">Name this account</label>
                                <input type="text" className='zaapGlobal-input h-30px bg-f3f3f3' name='account_name' onChange={handleChange} value={value?.account_name} required="required" placeholder="My Zapier account" />
                                <ModalErrors text={error} />
                            </div>
                            <div class="form-group mt-20px">
                                <label className='fs-12 font-weight-500' htmlFor="">Webhook URL</label>
                                <input type="url" class={`zaapGlobal-input h-30px bg-f3f3f3`} name={type} onChange={handleChange} value={value?.type} required="required" placeholder="Webhook URL" />
                                <ModalErrors text={error} />
                                <span className="fs-10px font-weight-500">Need help? Follow our guide doc <a href="https://www.genpage.ai/support" target="_blank" className="blue-text-navigate">here.</a></span>
                            </div>
                            <div className='d-flex gap-2 mt-20px p-0 align-items-center justify-content-center new-modal-footer'>
                                <button onClick={handleClose} className='fs-12 w-50 mt-0 integration-btns integration-btn-grey' type='button'>Cancel</button>
                                <button className='fs-12 w-50 shadow-none  project-blue-btn' type='submit'>Connect</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </Modal>
    )
}
export const ConnectInstantlyModal = ({ type, text, show, handleClose, handleSubmit, error }) => {
    const dispatch = useDispatch()
    const value = useSelector(state => state?.projectIntegrationsReducer);

    const handleChange = (e) => dispatch({ type: "SET_PROJECT_INTEGRATIONS", payload: { ...value, [e.target.name]: e.target.value, tab: "integrations" } });
    return (

        <Modal show={show} onHide={handleClose} className="rename-modal" centered>
            <div class="modal-content pt-0 pl-0 pr-0 pb-0 border-0 ">
                <div class="modal-header">
                <div className="d-flex gap-2 align-items-center">
                    <img src={integration_instantly} alt="" width={30}/>
                    <span>
                        Connect Instantly to GenPage
                    </span>
                </div> 
                    <button type="button" class="close" onClick={handleClose} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">

                    <form name="create_folder" method="post" role="form" onSubmit={(e) => handleSubmit(e, value, 'instantly')}>
                        <div class="notification-container"></div>

                        <div class="form-group">
                            <label className='fs-12 font-weight-500' htmlFor="">Name this account</label>
                            <input type="text" className='zaapGlobal-input h-30px bg-f3f3f3' name='account_name' onChange={handleChange} value={value?.account_name} required="required" placeholder="My Instantly account" />
                            <ModalErrors text={error} />
                        </div>
                        <div class="form-group mt-20px">
                            <label className='fs-12 font-weight-500' htmlFor="">API key</label>
                            <input type="text" className='zaapGlobal-input h-30px bg-f3f3f3' name='api_key' onChange={handleChange} value={value?.api_key} required="required" placeholder="Enter your API key" />
                            <ModalErrors text={error} />
                            <span className="fs-10px font-weight-500">Need help? Follow our guide doc <a href="https://www.genpage.ai/support" target="_blank" className="blue-text-navigate">here.</a></span>
                        </div>
                        <div className='d-flex gap-2 mt-20px p-0 align-items-center justify-content-center new-modal-footer'>
                            <button onClick={handleClose} className='fs-12 w-50 mt-0 integration-btns integration-btn-grey' type='button'>Cancel</button>
                            <button className='fs-12 w-50 shadow-none  project-blue-btn' type='submit'>Connect</button>
                        </div>
                    </form>
                </div>

            </div>
        </Modal>
    )
}